import { render, staticRenderFns } from "./ConfigureSettings.vue?vue&type=template&id=5755bf04&scoped=true"
import script from "./ConfigureSettings.vue?vue&type=script&lang=js"
export * from "./ConfigureSettings.vue?vue&type=script&lang=js"
import style0 from "./ConfigureSettings.vue?vue&type=style&index=0&id=5755bf04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5755bf04",
  null
  
)

export default component.exports